import parseNum from 'parse-num'

export function parseNumber (value) {
  let parsed = parseNum(value)
  if (isNaN(parsed)) parsed = null

  return parsed
}
